export default (to, from, next) => {

  if (process.env.VUE_APP_ENV === 'local' || process.env.VUE_APP_ENV === 'staging') {
    document.title = `[${process.env.VUE_APP_ENV}] ${document.title}`;
  }

  return next();
};
